import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const uploadFileToDocument = async (docId, file) => {
  //THROW IF NO DOC OR FILE

  let formData = new FormData();
  formData.append("ref", "api::document.document"); //name of content type
  formData.append("field", "body"); //name of key for the content type
  formData.append("files", file, file.name);
  formData.append("refId", docId); //id of content type


  let res = await axios.post(process.env.REACT_APP_BACKEND_URL + `api/upload`,
    formData, getAuthorizationHeader());

  return res.data.data;
}


export const updateDocument = async (docId, name) => {
  let data = {
    data: {
      name: name,
    }
  }

  let res = await axios.put(process.env.REACT_APP_BACKEND_URL + `api/documents/${docId}`, data,
      getAuthorizationHeader())

  return res.data.data;
}


export const createDocument = async (type, name, taskID) => {
    let data = {
      data: {
        type: type,
        name: name,
        task: taskID,
      }
    }

    let res = await axios.post(process.env.REACT_APP_BACKEND_URL + 'api/documents', data,
        getAuthorizationHeader())
  
    return res.data.data;
}

export const updateDocumentCase = async (docId, caseId) => {
  let data = {
    data: {
      case: caseId,
    }
  }

  let res = await axios.put(process.env.REACT_APP_BACKEND_URL + `api/documents/${docId}`, data,
      getAuthorizationHeader())

  return res.data.data;
}


export const updateDocumentCaseComments = async (docId, caseCommentId) => {
  let data = {
    data: {
      case_comment: caseCommentId,
    }
  }
  let res = await axios.put(process.env.REACT_APP_BACKEND_URL + `api/documents/${docId}`, data,
      getAuthorizationHeader())

  return res.data.data;
}

